module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-switch pt-15 pb-15 row"
  }, [_c('div', {
    staticClass: "gr-12@xs gr-6@sm gr-7@md"
  }, [_c('div', {
    staticClass: "question-switch__text"
  }, [_vm._v(_vm._s(_vm.question.content))]), (_vm.question.info) ? _c('div', {
    staticClass: "question-caption"
  }, [_c('div', {
    staticClass: "question-caption__content",
    domProps: {
      "innerHTML": _vm._s(_vm.question.info)
    }
  }), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()]), _c('div', {
    staticClass: "gr-12@xs gr-6@sm gr-5@md txt-center@xs txt-right@md"
  }, [(!_vm.isSimulation) ? _c('question-comment', {
    attrs: {
      "question": _vm.question,
      "tooltip": _vm.questionCommentTooltip,
      "comment-title": _vm.questionCommentTitle
    }
  }) : _vm._e(), _c('div', {
    staticClass: "answer",
    class: _vm.answerClass
  }, [_c('span', {
    staticClass: "answer__option",
    class: {
      'answer__option--active': _vm.question.answer === 'true'
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer('true')
      }
    }
  }, [_c('span', [_vm._v("Yes")])]), _c('span', {
    staticClass: "answer__option",
    class: {
      'answer__option--active': (typeof _vm.question.answer === 'undefined' || _vm.question.answer === null || _vm.question.answer === '')
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer(null)
      }
    }
  }, [_c('span', [_vm._v("•")])]), _c('span', {
    staticClass: "answer__option",
    class: {
      'answer__option--active': (_vm.question.answer === 'false')
    },
    on: {
      "click": function($event) {
        return _vm.setAnswer('false')
      }
    }
  }, [_c('span', [_vm._v("No")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ea486a7","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-switch.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4ea486a7","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-switch.vue
// module chunks = 0